import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const SellerDashboard: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Seller Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Seller dashboard coming soon...
      </Typography>
    </Container>
  );
};

export default SellerDashboard;
